import * as tslib_1 from "tslib";
import { select } from '@angular-redux/store';
import { Observable } from 'rxjs';
import { ThemeOptions } from '../../../theme-options';
export class HeaderComponent {
    constructor(globals) {
        this.globals = globals;
    }
    get isActiveAsGetter() {
        return this.isActive;
    }
    toggleSidebarMobile() {
        this.globals.toggleSidebarMobile = !this.globals.toggleSidebarMobile;
    }
    toggleHeaderMobile() {
        this.globals.toggleHeaderMobile = !this.globals.toggleHeaderMobile;
    }
}
tslib_1.__decorate([
    select('config'),
    tslib_1.__metadata("design:type", Observable)
], HeaderComponent.prototype, "config$", void 0);
